const DEFAULT_MYSTORE_BASE_URL = "https://mystore.edible.tech/";
const DEFAULT_KEY_VAULT_SETTINGS_PATH = "/api/store/key-vault";
const DEFAULT_PROFIT_LOSS_TILE_ENABLED_SETTING_KEY = "ProfitLossTileEnabled";

const normalizeBaseUrl = (value: string): string => {
  return value.endsWith("/") ? value.slice(0, -1) : value;
};

const getRuntimeConfigValue = (key: string): string | undefined => {
  const runtimeConfig = globalThis as typeof globalThis & Record<string, unknown>;
  const runtimeValue = runtimeConfig[key];
  return typeof runtimeValue === "string" && runtimeValue.trim() ? runtimeValue.trim() : undefined;
};

export const MYSTORE_BASE_URL = normalizeBaseUrl(
  getRuntimeConfigValue("REACT_APP_MYSTORE_BASE_URL") ||
    process.env["REACT_APP_MYSTORE_BASE_URL"] ||
    DEFAULT_MYSTORE_BASE_URL
);

export const buildMyStoreUrl = (path: string): string => {
  return `${MYSTORE_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

export const buildMyStoreKeyVaultUrl = (key: string): string => {
  const query = new URLSearchParams({ key });
  return `${buildMyStoreUrl(DEFAULT_KEY_VAULT_SETTINGS_PATH)}?${query.toString()}`;
};

export const PROFIT_LOSS_TILE_ENABLED_SETTING_KEY =
  getRuntimeConfigValue("REACT_APP_PROFIT_LOSS_TILE_ENABLED_SETTING_KEY") ||
  process.env["REACT_APP_PROFIT_LOSS_TILE_ENABLED_SETTING_KEY"] ||
  DEFAULT_PROFIT_LOSS_TILE_ENABLED_SETTING_KEY;
